// src/encounter/lib/discard-draft.ts
//
// D-73 (design desk, 6 Oct 2026; switch ON and OFF): an editor whose typed text changed and is not saved asks
// before it closes — the DS confirm "Discard this text?" with "Keep editing" (default focus) and "Discard".
// In a dialog, X, Esc or a click outside asks only if the text changed; Save never asks. Found live on dev
// (97558a3): closing "Add Text Notes" with typed text threw the text away with no prompt.
import type { RichTextOp } from '@scripsteam/scrips-signal-ds';

/**
 * The text a draft holds, for the discard prompt (D-73): every text run, and every embed (a piece) by its
 * value, so filling a piece counts as a change. Trailing whitespace (Quill's terminal newline) is ignored,
 * so opening and closing an untouched note never asks.
 */
export function draftText(ops: readonly RichTextOp[]): string {
  return ops
    .map((op) => (typeof op.insert === 'string' ? op.insert : op.insert ? JSON.stringify(op.insert) : ''))
    .join('')
    .replace(/\s+$/, '');
}

/** The confirm's title (D-73). */
export const DISCARD_TITLE = 'Discard this text?';
